import {
	Card, HStack, Stack, Text,
} from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import React from 'react';

import { AppRoutes } from '@/constants/route';
import { NextLinkButton } from '@/modules/navigation/presentation';

type JobApplicationCompletedProps = {
	companyName: string
	jobTitle:    string
};

const Field = ({ title, value }: {
	title: string
	value: string
}) => (
	<HStack>
		<Card.Title flex={1} textStyle="bodyBold">
			{title}
		</Card.Title>
		<Text flex={3}>
			{value}
		</Text>
	</HStack>
);

export const JobApplicationCompleted = ({ companyName, jobTitle }: JobApplicationCompletedProps) => {
	const t = useTranslations('jobs.application.success');

	return (
		<Stack gap="md">
			<Stack alignItems="center" textAlign="center">
				<Text color="primary.120" textStyle="h3">
					{t('title')}
				</Text>
			</Stack>
			<Card.Root mb={6}>
				<Card.Body gap="sm" p={4}>
					<Field title={t('companyName')} value={companyName} />
					<Field title={t('jobTitle')} value={jobTitle} />
				</Card.Body>
			</Card.Root>
			<Stack gap="sm">
				<Text textAlign="center">
					{t('messages.helperText')}
				</Text>
				<NextLinkButton colorPalette="secondary" href={AppRoutes.jobs.saved}>
					{t('actions.interested')}
				</NextLinkButton>
			</Stack>
		</Stack>
	);
};
